import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBezierAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bezier-add, vector, nodes"} maskId="square-filled-radius-0-stroke-1-IconBezierAdd"><path fillRule="evenodd" clipRule="evenodd" d="M3 3V9H5.5V15H3V21H8.75V18.5H15V21H21V15H18.5V9H21V3H15V5.5H9V3H3ZM9 6.5H15V9H17.5V15H15V17.5H8.75V15H6.5V9H9V6.5Z" fill="currentColor"/><path d="M12.5 9H11.5V11.5H9V12.5H11.5V15H12.5V12.5H15V11.5H12.5V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBezierAdd;
